// 腾讯广告小游戏sdk
import {
    SDK
} from '@dn-sdk/minigame';

module.exports = SDK